import * as _ from 'lodash';
import { type VoidFunctionComponent } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import Locator from '../../../../shared/Locator';
import { useNoticeFiles } from '../../../hooks/api';
import { Action, ResourceType, useHasPermission } from '../../../shared/permissions';
import { icons } from '../../generic';
import Button from '../../generic/Button';
import Loader from '../../generic/Loader';
import ManageNoticeFile from './ManageNoticeFile';

type NoticeFilesProps = {
  revisionLocator: string;
};

const NoticeFiles: VoidFunctionComponent<NoticeFilesProps> = ({ revisionLocator }) => {
  const notices = useNoticeFiles(revisionLocator);
  const hasPermission = useHasPermission();

  const projectId = new Locator(revisionLocator).toPackageString();
  const canEdit = hasPermission({ resourceType: ResourceType.Project, action: Action.Edit, projectId });

  if (notices.isLoading) {
    return (
      <div>
        <div className="fossa-form__label__text">Notice Files</div>
        <ListGroup>
          <ListGroupItem><Loader /></ListGroupItem>
        </ListGroup>
      </div>
    );
  }

  if (notices.isError) {
    return (
      <div>
        <div className="fossa-form__label__text">Notice Files</div>
        <ListGroup>
          <ListGroupItem>
            <div>Unfortunately FOSSA can not load this component&apos;s notice files. Please try again later.</div>
          </ListGroupItem>
        </ListGroup>
      </div>
    );
  }

  return (
    <div>
      <div className="fossa-form__label__text">Notice Files</div>
      {notices.data.length > 0 && (
        <ListGroup>
          {notices.data.map(file => <ManageNoticeFile file={file} />)}
        </ListGroup>
      )}
      <Button
        size="large"
        type="secondary"
        icon={icons.plusSquareO}
        onClick={_.noop}
        isDisabled={canEdit}
      >
        Add a notice file
      </Button>
    </div>
  );
};

export default NoticeFiles;
